import React, { FunctionComponent } from "react";

import { Caption, GridColumnCount, GridGapSize, GridLayout, GridLayoutItem } from "@multiweb/reactComponents";
import { LOC_DESCRIPTION, LOC_NAME } from "../../../../../locKeys";
import { ISet, WorkflowEditorProps } from "../../../../../types";
import { Edit, Memo } from "../../../components";

type SetEditPageProps = {
    readonly selectedSet: ISet;
    readonly updateSet: (newSet: ISet) => void;
} & WorkflowEditorProps;

export const SetEditPage: FunctionComponent<SetEditPageProps> = ({ hostKey, selectedSet, updateSet }) => {
    const onChangeSetName = (e: React.ChangeEvent<HTMLInputElement>) => {
        updateSet({ ...selectedSet, name: e.target.value });
    };

    const onChangeSetDescription = (e: React.ChangeEvent<HTMLTextAreaElement>) => {
        updateSet({ ...selectedSet, description: e.target.value });
    };

    return (
        <GridLayout columns={GridColumnCount.one} gap={GridGapSize.two}>
            <GridLayoutItem>
                <Caption required locKey={LOC_NAME} />
                <Edit required maxLength={64} value={selectedSet.name} onChange={onChangeSetName} {...{ hostKey }} />
            </GridLayoutItem>
            <GridLayoutItem>
                <Caption locKey={LOC_DESCRIPTION} />
                <Memo value={selectedSet.description} onChange={onChangeSetDescription} {...{ hostKey }} />
            </GridLayoutItem>
        </GridLayout>
    );
};
